import React from 'react';
import SEOHelmet from '../SEOHelmet';

const HapurPage: React.FC = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    //eslint-disable-next-line
  }, []);

  return (
    <div className='mt-24 mb-20 max-w-4xl mx-auto px-4'>
      <SEOHelmet />
      <h1 className='text-3xl md:text-5xl font-bold text-center mb-8'>Brain & Spine Neurosurgical Care for Hapur | Dr. Gangesh Gunjan</h1>
      
      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Specialized Neurosurgical Care for Hapur Patients</h2>
        <p className='text-lg text-gray-700 leading-relaxed'>Dr. Gangesh Gunjan offers dedicated clinical consultations and surgical evaluations for patients travelling from Hapur and Western UP. Based at Sarvodaya Hospital, Greater Noida West, Dr. Gunjan provides comprehensive neurosurgical management for cranial pathologies, spinal disorders, and pediatric neurological conditions.</p>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Brain and Spine Surgical Procedures</h2>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Awake craniotomy for functional cortex lesions</li>
          <li>Minimally invasive spine surgery (MISS) for lumbar disc herniation and stenosis</li>
          <li>Neuroendoscopy for intraventricular lesions and obstructive hydrocephalus</li>
          <li>Neuronavigation-assisted spinal fixation and decompression</li>
          <li>Surgical management of cranial and spinal tumors</li>
        </ul>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Clinical Conditions Evaluated</h2>
        <p className='text-lg text-gray-700 mb-3'>Patients from Hapur consult for evaluation and treatment of:</p>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Traumatic brain and spinal cord injuries requiring urgent stabilization</li>
          <li>Cerebrovascular disorders (aneurysms, vascular malformations)</li>
          <li>Degenerative spine conditions, sciatica, and herniated discs</li>
          <li>Medically refractory epilepsy evaluation</li>
          <li>Brain and spine tumors requiring multidisciplinary management</li>
          <li>Congenital pediatric neurological disorders</li>
        </ul>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Multidisciplinary Neuro-Oncology Approach</h2>
        <p className='text-lg text-gray-700 leading-relaxed mb-3'>Complex neuro-oncology cases are managed in coordination with medical oncologists, radiation specialists, and histopathologists to design individualized, evidence-based treatment plans:</p>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Targeted stereotactic radiosurgery coordination</li>
          <li>Histopathological and molecular tumor profiling review</li>
          <li>Preoperative MRI fusion and intraoperative tracking</li>
          <li>Coordinated post-operative recovery monitoring</li>
        </ul>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Pediatric Neurosurgery Care</h2>
        <p className='text-lg text-gray-700 leading-relaxed mb-3'>Dr. Gunjan provides clinical evaluations for pediatric patients presenting with:</p>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Congenital brain and spinal dysraphisms (spina bifida, tethered cord)</li>
          <li>Hydrocephalus and ventriculoperitoneal (VP) shunt management</li>
          <li>Pediatric cranial and posterior fossa tumors</li>
          <li>Craniosynostosis and skull shape abnormalities</li>
        </ul>
      </section>

      <section className='mb-8 bg-blue-50 p-6 rounded-2xl border border-blue-100'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-3 text-blue-900'>Consultation Details for Hapur Residents</h2>
        <p className='text-lg text-gray-700 leading-relaxed mb-4'>
          To book a neurosurgical appointment with Dr. Gangesh Gunjan, please call{' '}
          <a href="tel:+917727834367" className='text-blue-600 font-semibold hover:underline'>+91-7727834367</a>{' '}
          or visit the Department of Neurosurgery, Room no. 1011, Sarvodaya Hospital, Sector 16C, Gaur City 2, Greater Noida West.
        </p>
      </section>
    </div>
  );
};

export default HapurPage;